import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { Stack, Typography } from "@mui/material";

import { PortalInvitationCard } from "@/common/components/portal-access/components/PortalInvitationCard";
import { useTranslation } from "@/translations";

interface Props {
  email: string;
  onSend: () => void;
  isSending: boolean;
}

/**
 * The volunteer flavour of the initial-activation card. Unlike the client flow there is no address
 * selection — the invitation goes to the volunteer's single stored e-mail address, shown read-only.
 */
export function VolunteerInvitationCard({ email, onSend, isSending }: Props) {
  const { t } = useTranslation();

  return (
    <PortalInvitationCard
      description={t("volunteers.access.invitation.description")}
      noEmailHint={t("volunteers.access.invitation.noEmail")}
      hasEmail={email.trim() !== ""}
      onSend={onSend}
      isSending={isSending}
    >
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        p={1.5}
        sx={{ backgroundColor: (theme) => theme.palette.fsw["grey-25"], width: "100%" }}
      >
        <EmailOutlinedIcon fontSize="small" color="action" />
        <Typography variant="body2">{t("volunteers.access.invitation.emailInfo", { email })}</Typography>
      </Stack>
    </PortalInvitationCard>
  );
}
